<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Hireds') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({hired_date: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <div class="p-3" style="width: 100%; overflow: hidden;">
              <ul class="nav nav-tabs mb-4">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    :class="{active: showChart === 1}"
                    href="javascript:void(0)"
                    @click="showChart=1">Contratados no período</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    :class="{active: showChart === 2}"
                    href="javascript:void(0)"
                    @click="showChart=2">Tempo médio para contratar</a>
                </li>
              </ul>

              <highcharts
                v-show="showChart === 1"
                :options="chartOptions1">
                </highcharts>
              <highcharts
                v-show="showChart === 2"
                :options="chartOptions2">
                </highcharts>
            </div>
            <div style="height: 100%; overflow-x: scroll;">
              <table class="table table-bordered">
                <thead class="thead-fixed">
                  <tr>
                    <th-sort
                      field="candidate.name"
                      :value="sort"
                      @input="setSort">{{ $t('Name') }}</th-sort>
                    <th-sort
                      field="candidate.email"
                      :value="sort"
                      @input="setSort">{{ $t('Email') }}</th-sort>
                    <th-sort
                      field="candidate.phones"
                      :value="sort"
                      @input="setSort">{{ $t('Phone') }}</th-sort>
                    <th-sort
                      field="job.title"
                      :value="sort"
                      @input="setSort">{{ $t('Job') }}</th-sort>
                    <th-sort
                      field="job.company.name"
                      :value="sort"
                      @input="setSort">{{ $t('Company') }}</th-sort>
                    <th-sort
                      field="job.departament.name"
                      :value="sort"
                      @input="setSort">{{ $t('Department') }}</th-sort>
                    <th-sort
                      field="referral_email"
                      :value="sort"
                      @input="setSort">Indicado por</th-sort>
                    <th-sort
                      field="hired_date"
                      :value="sort"
                      @input="setSort">Data da contratação</th-sort>
                    <th-sort
                      field="time_to_hire"
                      :value="sort"
                      @input="setSort">Tempo para contratação</th-sort>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in grid.docs">
                    <td class="text-truncate">
                      <router-link
                        v-if="item.candidate"
                        :to="candidateRoute(item.candidate._id, item.job._id)">
                        {{ item.candidate.name }}
                        </router-link>
                    </td>
                    <td class="text-truncate">{{ item.candidate.email }}</td>
                    <td class="text-truncate">{{ getPhones(item.candidate.phones) }}</td>
                    <td class="text-truncate"><router-link :to="{path: '/job/' + item.job._id }">{{ item.job.title }}</router-link> #{{ item.job.code }}</td>
                    <td class="text-truncate">{{ item.job.company.name }}</td>
                    <td class="text-truncate">{{ item.job.departament.name }}</td>
                    <td class="text-truncate">{{ item.referral_email }} <span v-if="item.referral_name">({{ item.referral_name }})</span></td>
                    <td class="text-truncate">{{ $d(new Date(item.hired_date), 'short') }}</td>
                    <td class="text-truncate">{{ item.time_to_hire }}d</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
    </div>

  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'Hireds',
  components: {
    highcharts: Chart,
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'job.company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'job.departament_id',
          'resource': 'departaments'
        }
      ],
      grid: false,
      trend: false,
      timeToHireTrend: false,
      showChart: 1
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-hired_date'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.hired_date === undefined ? defaultDate : this.$route.query.hired_date
    },
    chartOptions1 () {
      if (this.trend) {
        return {
          title: {
            text: 'Candidatos contratados no período'
          },
          yAxis: {
            title: {
              text: null
            }
          },
          xAxis: {
            categories: this.trend.map(v => v.label)
          },
          series: [{
            name: 'Candidatos',
            data: this.trend.map(v => v.total)
          }]
        }
      }
      return null
    },
    chartOptions2 () {
      if (this.trend) {
        return {
          title: {
            text: 'Tempo médio para contratar (Dias)'
          },
          yAxis: {
            title: {
              text: null
            }
          },
          xAxis: {
            categories: this.trend.map(v => v.label)
          },
          series: [{
            name: 'Dias',
            data: this.timeToHireTrend.map(v => v.total)
          }]
        }
      }
      return null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        hired_date: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      Promise.all([
        this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reports/hireds', {params: params}),
        this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reports/hireds-trend', {params: params}),
        this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reports/time-to-hire-trend', {params: params})
      ])
      .then(response => {
        this.grid = response[0].data
        this.trend = response[1].data
        this.timeToHireTrend = response[2].data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    getPhones (phones) {
      return phones && typeof (phones) === 'object' ? phones.join(', ') : ''
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/hireds/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    },
    candidateRoute (candidateId, jobId) {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: candidateId,
          candidate_job_id: jobId
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportHireds.vue